<template>
  <div class="d-flex flex-column align-items-center">
    <div
      class="d-flex align-items-center justify-content-center flex-column mb-0"
      :key="indexDiv"
    >
      <h6 class="text-center m-0">
        {{ titulo }}
      </h6>
      <b-button
        variant="link"
        class="font-weight-bold"
        style="
          color: #b5b5c3;
          font-size: 12px;
          margin-top: -0.5rem;
          text-transform: capitalize;
        "
        @click="abrirDetalhes"
      >
        ver detalhes
      </b-button>
    </div>

    <apexchart
      type="donut"
      :height="400"
      :width="250"
      :options="chartOptions"
      :series="series()"
      ref="chart"
      class="mt-4"
    ></apexchart>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
export default {
  name: "CampanhaPieChartCustom",
  components: {
    // Tooltip
  },
  props: {
    titulo: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    colorLabel: {
      type: String,
      default: "cor"
    },
    reverse: {
      type: Boolean,
      default: true
    },
    card_id: {
      type: Number
    }
  },
  computed: {},
  methods: {
    series() {
      let series = this.data.map((item) => item.valor);
      if (this.reverse) {
        series = series.reverse();
      }
      return series;
    },
    colors() {
      let colors = this.data.map((item) => item[this.colorLabel]);
      if (this.reverse) {
        colors = colors.reverse();
      }
      return colors;
    },
    labels() {
      let labels = this.data.map((item) => item.label);
      if (this.reverse) {
        labels = labels.reverse();
      }
      return labels;
    },
    formatterMethod() {
      const total = this.data.reduce((acc, item) => acc + item.valor, 0);
      if (this.data.some((item) => item.label.includes("Respostas"))) {
        const aprovadoValor = this.data.reduce(
          (acc, item) =>
            item.label.includes("Respostas") ? acc + item.valor : acc,
          0
        );
        return `${((aprovadoValor / total) * 100).toFixed(1)}%`;
      }
      if (this.data.some((item) => item.label.includes("Aprov"))) {
        const aprovadoValor = this.data.reduce(
          (acc, item) =>
            item.label.includes("Aprov") ? acc + item.valor : acc,
          0
        );
        return `${((aprovadoValor / total) * 100).toFixed(1)}%`;
      }
      if (this.data.some((item) => item.label === "Sucesso")) {
        const sucessoValor =
          this.data.find((item) => item.label === "Sucesso")?.valor || 0;
        return `${((sucessoValor / total) * 100).toFixed(1)}%`;
      }
      return "0%";
    },
    labelFormatter() {
      if (
        this.data.some((item) =>
          ["Respostas", "Sem retorno"].includes(item.label)
        )
      ) {
        return "Respostas";
      }
      if (
        this.data.some((item) =>
          ["Aprovado", "Aprov", "Recusado", "Novo Agendamento"].includes(
            item.label
          )
        )
      ) {
        return "Aprovado";
      }
      if (
        this.data.some((item) =>
          ["Sucesso", "Pendente", "Erro"].includes(item.label)
        )
      ) {
        return "Sucesso";
      }
      return "";
    },
    abrirDetalhes() {
      this.$emit("abrirDetalhesCampanhaEstatistica", this.card_id);
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "donut",
          toolbar: {
            show: false
          },
          offsetY: 0,
          dropShadow: {
            enabled: false,
            color: "#111",
            top: -1,
            left: 3,
            blur: 3,
            opacity: 0.5
          }
        },
        stroke: {
          enabled: false,
          width: 0,
          colors: ["#ccc"]
        },
        colors: this.colors(),
        labels: this.labels(),
        dataLabels: {
          enabled: false
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "12px",
                  fontWeight: 400
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  offsetY: 16
                },
                total: {
                  show: true,
                  showAlways: false,
                  label: this.labelFormatter(),
                  fontSize: "12px",
                  formatter: this.formatterMethod
                }
              }
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              }
            }
          }
        ]
      },
      indexDiv: 0
    };
  }
};
</script>

<style lang="scss" scoped>
::v-deep .apexcharts-text.apexcharts-datalabel-value {
  font-size: 24px !important;
  transform: translateY(-20px) !important;
  font-weight: 600;
}

::v-deep .apexcharts-legend.apexcharts-align-center.apx-legend-position-bottom {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  bottom: 5px !important;
}
</style>
